import React from "react";

//components
import { FormLoginV2 } from "@components/UcrComponent/auth";

//boostrap
import { Container } from "reactstrap";

function LoginUcr2Page(props) {
  return (
    <div className="wrapper -loginPartnerPage">
      <div className="loginPartnerContainer">
        <Container>
          <FormLoginV2 />
        </Container>
      </div>
    </div>
  );
}

export default LoginUcr2Page;